module.exports = __webpack_public_path__ + "media/images/front/icons/profile_edit_default-3473c8ea8cd050976e29275615346f30.png";